import React from 'react';
import { Box, Card, CardContent } from '@mui/material';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

/**
 * Skeleton Card for Package Card loading state
 */
const SkeletonCard = ({ count = 1 }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <Card
          key={index}
          sx={{
            borderRadius: 3,
            overflow: 'hidden',
            boxShadow: 2,
          }}
        >
          {/* Image skeleton */}
          <Skeleton height={250} />

          <CardContent sx={{ p: 2.5 }}>
            {/* Title skeleton */}
            <Skeleton height={28} width="85%" style={{ marginBottom: 12 }} />

            {/* Description skeleton */}
            <Skeleton height={16} count={2} style={{ marginBottom: 16 }} />

            {/* Badges skeleton */}
            <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
              <Skeleton height={24} width={80} borderRadius={12} />
              <Skeleton height={24} width={60} borderRadius={12} />
            </Box>

            {/* Price section skeleton */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Box>
                <Skeleton height={14} width={100} style={{ marginBottom: 4 }} />
                <Skeleton height={32} width={80} />
              </Box>
              <Skeleton height={40} width={40} circle />
            </Box>
          </CardContent>
        </Card>
      ))}
    </>
  );
};

export default SkeletonCard;
